import { Directive, ElementRef, HostListener, inject, Input, input } from '@angular/core';

@Directive({
  selector: '[evTrimOnPaste]',
  standalone: false
})
export class TrimOnPasteDirective {
  @Input() removeWhitespaces = false;

  private readonly elementRef = inject(ElementRef);

  private get element(): HTMLInputElement {
    return this.elementRef.nativeElement;
  }

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent) {
    event.preventDefault();

    const clipboardData = event.clipboardData || window['clipboardData'];
    const pastedText = clipboardData.getData('text/plain');

    const trimmedText = this.removeWhitespaces ? pastedText.replace(/\s+/g, '') : pastedText.trim();

    const start = this.element.selectionStart || 0;
    const end = this.element.selectionEnd || 0;
    const value = this.element.value;

    this.element.value = value.substring(0, start) + trimmedText + value.substring(end);

    // Move the cursor to the end of the pasted text
    const newCursorPosition = start + trimmedText.length;
    this.element.setSelectionRange(newCursorPosition, newCursorPosition);

    this.element.dispatchEvent(new Event('input'));
  }
}
